export default array => {
  if (array) {
    let output = {};
    array.forEach(shop => {
      if (shop.category && !shop.hasOwnProperty('disabled')) {
        const parentId =
          shop &&
          shop.category &&
          shop.category.parent &&
          shop.category.parent.id;
        const categoryId = shop.category.id;
        if (!output.hasOwnProperty(parentId)) {
          output[parentId] = {
            id: parentId,
            label:
              shop &&
              shop.category &&
              shop.category.parent &&
              shop.category.parent.detail &&
              shop.category.parent.detail.label,
            children: {}
          };

          output[parentId].children[categoryId] = {
            id: categoryId,
            label: shop.category.detail.label,
            categorySlug: shop.category.detail.slug,
            parentType: shop.type,
            items: [
              {
                id: shop.id,
                name: shop.name,
                slug: shop.slug,
                type: shop.type,
                imgDesk: shop.imgDesk,
                logoDesk: shop.logo1Desk,
                logoDesk2: shop.logo2Desk,
                is_new: shop.is_new,
                is_heart: shop.is_heart
              }
            ]
          };
        } else {
          if (!output[parentId].children.hasOwnProperty(categoryId)) {
            output[parentId].children[categoryId] = {
              id: shop.category.id,
              label: shop.category.detail.label,
              categorySlug: shop.category.detail.slug,
              parentType: shop.type,
              items: [
                {
                  id: shop.id,
                  name: shop.name,
                  slug: shop.slug,
                  type: shop.type,
                  imgDesk: shop.imgDesk,
                  logoDesk: shop.logo1Desk,
                  logoDesk2: shop.logo2Desk,
                  is_new: shop.is_new,
                  is_heart: shop.is_heart
                }
              ]
            };
          } else {
            output[parentId].children[categoryId].items = output[
              parentId
            ].children[categoryId].items.concat({
              id: shop.id,
              name: shop.name,
              slug: shop.slug,
              type: shop.type,
              imgDesk: shop.imgDesk,
              logoDesk: shop.logo1Desk,
              logoDesk2: shop.logo2Desk,
              is_new: shop.is_new,
              is_heart: shop.is_heart
            });
          }
        }
      }
    });

    return output;
  }
};
